import { render, staticRenderFns } from "./app-auth.vue?vue&type=template&id=97912258"
import script from "./app-auth.vue?vue&type=script&lang=js"
export * from "./app-auth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports